import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  Component,
} from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getStartOfMonth,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import MobileInput from "../MobileInput/MobileInput";
import DragDrop from "../DragDrop/DragDrop";
import { useSearchParams } from "react-router-dom";
import QuillEditor from "../QuillEditor";
import { showErrorMessage, showSuccessMessage } from "../Shared/Toast";

interface Template {
  PTHTMLTemplateID: number;
  Name: string;
}

interface MVLocation {
  MVLocationsID: number;
  Name: string;
}

interface InfoObject {
  ComponentName: string;
  TypeID: number;
  PTHTMLTemplateID: number;
  HTMLContents: string;
}

interface ApiResponse {
  data: {
    templates?: Template[];
    locations?: MVLocation[];
  };
}

function Pages() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [screenFields, setScreenFields] = useState<any[]>([]);
  const [addEditObject, setAddEditObject] = useState<any>({
    PTStaticPageID: 0,
    Name: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    ExtraTextField1: "",
    ExtraTextField2: "",
    PTOrderBy: 0,
    IsHideHeader: false,
    IsHideFooter: false,
    Media: [],
  });
  const [screenData, setScreenData] = useState<any>([]);
  const [dropDowndata, setDropDowndata] = useState<any>([]);
  const [linkedRolesData, setLinkedRolesData] = useState<any>([]);
  const [rolesData, setRolesData] = useState<any>([]);
  const [isAddNewComponent, setIsAddNewComponent] = useState<number>(0);

  useEffect(() => {
    LoadUsersData();
  }, []);

  function LoadUsersData() {
    let object = {} as any;
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL + "api/PTStaticPage/PTStaticPageGetCompleteGridData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          l_oResponse = FilterJsonExactlyMatching(
            l_oResponse,
            "IsDeleted",
            false
          );
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "UserReviewID",
              selectedMoverID
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation(actionType?: string) {
    var IsOkay = true;
    if (!addEditObject.Name || addEditObject.Name == "") {
      showErrorMessage("Please enter Page Name");
      IsOkay = false;
    } else if (!addEditObject.MetaTitle || addEditObject.MetaTitle == "") {
      showErrorMessage("Please enter Meta Title");
      IsOkay = false;
    } else if (
      !addEditObject.MetaKeywords ||
      addEditObject.MetaKeywords == ""
    ) {
      showErrorMessage("Please enter Meta Keywords");
      IsOkay = false;
    }

    // if (IsOkay == true) {
    //   SaveFiles();
    // }
    if (IsOkay == true) {
      showSuccessMessage("Component saved!");
      SaveFiles();
    }
    if (actionType === "copy") {
      showSuccessMessage("Link copied successfully!");
      return;
    }
  }

  function saveScreenData(files: any) {
    setIsAnimation(true);
    let object = {
      PTStaticPageID: addEditObject.PTStaticPageID ?? 0,
      Name: addEditObject.Name || "Untitled Page",
      MetaTitle: addEditObject.MetaTitle || "",
      MetaDescription: addEditObject.MetaDescription || "",
      MetaKeywords: addEditObject.MetaKeywords || "",
      IsHideHeader: addEditObject.IsHideHeader ?? false,
      IsHideFooter: addEditObject.IsHideFooter ?? false,
      ExtraTextField1: addEditObject.ExtraTextField1 || "0",
      ExtraTextField2: addEditObject.ExtraTextField2 || "",
      PTOrderBy: addEditObject.PTOrderBy ?? 0,
      Media: files && files.length > 0 ? [{ FileURL: files[0].FileURL }] : [],
    };
    // if (files && files.length > 0) {
    //   object.ImageURL = files[0].FileURL;
    // } else {
    //   object.ImageURL = addEditObject.ImageURL;
    // }

    axiosAuth
      .post(AppContext.APIURL + "api/PTStaticPage/AjaxSavePageData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response && l_response[0] && l_response[0][0].Status == 0) {
            showErrorMessage(l_response[0][0].Message);
          } else {
            setIsAddNew(0);
          }
          LoadUsersData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  interface PageItem {
    PTStaticPageID: number;
    Status: number;
    [key: string]: any;
  }

  const handleStatusChange = (item: PageItem, newStatus: number): void => {
    const requestData = {
      PTStaticPageID: item.PTStaticPageID,
      Status: newStatus,
    };

    axiosAuth
      .post(
        AppContext.APIURL + "api/PTStaticPage/UpdatePageStatus",
        requestData
      )
      .then((response) => {
        if (response.data.Status === 1) {
          setThisGridListData((prev: PageItem[]) =>
            prev.map((row: PageItem) =>
              row.PTStaticPageID === item.PTStaticPageID
                ? { ...row, Status: newStatus }
                : row
            )
          );
        }
      })
      .catch((error) => {
        console.error("Error updating status:", error);
      });
  };

  useEffect(() => {
    const loadScreenFields = async () => {
      try {
        const response = await axiosAuth.post(
          AppContext.APIURL + "api/PTStaticPage/GetScreenFieldsData",
          {}
        );

        if (response?.data?.Status === 1 && Array.isArray(response.data.Data)) {
          const data = response.data.Data;
          setHtmlTemplates(Array.isArray(data[1]) ? data[1] : []);
          setMvLocations(Array.isArray(data[2]) ? data[2] : []);
        } else {
          setHtmlTemplates([]);
          setMvLocations([]);
        }
      } catch (err) {
        console.error("Error loading screen fields:", err);
        setHtmlTemplates([]);
        setMvLocations([]);
      }
    };

    loadScreenFields();
  }, []);

  const loadScreenFieldsData = () => {
    let object = {} as any;

    axiosAuth
      .post(AppContext.APIURL + "api/PTStaticPage/GetScreenFieldsData", object)
      .then((response) => {
        if (
          response.data.Status === 1 &&
          response.data.Data &&
          response.data.Data[0]
        ) {
          const result = response.data.Data[0];
          // console.log("Screen fields loaded:", result);
          setScreenFields(result);
        } else {
          setScreenFields([]);
        }
      })
      .catch((error) => {
        console.error("Error loading screen fields:", error);
        setScreenFields([]);
      });
  };

  const handleAddNew = () => {
    setAddEditObject({
      PTStaticPageID: 0,
      Name: "Untitled Page",
      PTOrderBy: 0,
      MetaTitle: "",
      MetaDescription: "",
      MetaKeywords: "",
      IsHideHeader: false,
      IsHideFooter: false,
      ExtraTextField1: "0",
      ExtraTextField2: "",
      Media: [],
    });
    // setShowModal(true); // agar modal kholna hota hai to
  };

  function normalizeValue(value: any): string {
    if (value == null || value === undefined) return "";
    if (typeof value !== "string") return String(value);

    return value.replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "");
  }

  function handleBlurSave(fieldName: string, value: any) {
    const normalizedValue = value;

    const object: any = {
      PTStaticPageID: addEditObject?.PTStaticPageID ?? 0,
      Name: addEditObject?.Name ?? "",
      MetaTitle: addEditObject?.MetaTitle ?? "",
      MetaKeywords: addEditObject?.MetaKeywords ?? "",
      MetaDescription: addEditObject?.MetaDescription ?? "",
      ExtraTextField1: addEditObject?.ExtraTextField1 ?? "",
      ExtraTextField2: addEditObject?.ExtraTextField2 ?? "",
      PTOrderBy: addEditObject?.PTOrderBy ?? 0,
      IsHideHeader: addEditObject?.IsHideHeader ?? false,
      IsHideFooter: addEditObject?.IsHideFooter ?? false,
      Status: addEditObject.Status,
    };

    object[fieldName] = normalizedValue;

    axiosAuth
      .post(AppContext.APIURL + "api/PTStaticPage/AjaxSavePageData", object)
      .then(() => {
        // console.log(`${fieldName} updated successfully`);
      })
      .catch((error) => {
        console.error("Error updating field:", error);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.PTStaticPageID = pid;

    axiosAuth
      .post(
        AppContext.APIURL + "api/PTStaticPage/PTStaticPageDeleteRecord",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          // SaveFiles();
          LoadUsersData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  // file upload code
  const [previewUrl, setPreviewUrl] = useState<string>("");
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  const baseUrl = "https://appdev.finestvan.co.uk";
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    loadFilteredData();
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
    if (searchObject.searchTerm !== "" || searchObject.statusFilter !== "All") {
      searchObject.searchTerm = "";
      searchObject.statusFilter = "All";
      loadFilteredData();
    }
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "Name")) {
        (
          document.getElementById("imgSort" + "Name") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MetaTitle")) {
        (
          document.getElementById("imgSort" + "MetaTitle") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MetaDescription")) {
        (
          document.getElementById(
            "imgSort" + "MetaDescription"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MetaKeywords")) {
        (
          document.getElementById(
            "imgSort" + "MetaKeywords"
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  // const [searchTerm, setSearchTerm] = useState("");
  // const [statusFilter, setStatusFilter] = useState("All");
  const [searchObject, setSearchObject] = useState({
    searchTerm: "",
    statusFilter: "All",
  });
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadFilteredData = () => {
    setIsAnimation(true);

    const requestData: any = {
      Title: searchObject.searchTerm.trim(),
    };

    if (searchObject.statusFilter === "Active") requestData.Status = 1;
    else if (searchObject.statusFilter === "InActive") requestData.Status = 0;

    // setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTStaticPage/LoadPagesData", requestData)
      .then((response) => {
        const res = response.data;
        if (res?.Status === 1 && res?.Data?.length > 0) {
          const result = res.Data[0];
          setThisGridListData(result);
          setThisGridListDataWithoutFilters([...result]);
          thisGridListDataRef.current = result;
        } else {
          setThisGridListData([]);
          setThisGridListDataWithoutFilters([]);
          thisGridListDataRef.current = [];
        }
        // setIsAnimation(true);
      })
      .catch((error) => {
        console.error("Error loading filtered data:", error);
        setThisGridListData([]);
        setThisGridListDataWithoutFilters([]);
        thisGridListDataRef.current = [];
      })
      .finally(() => setIsAnimation(false));
  };

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");

  useEffect(() => {
    // console.log("Mobile", addEditObject.Mobile);
    SetSelectedMobileNumber(addEditObject.Mobile);
  }, [addEditObject.Mobile, isAddNew]);

  useEffect(() => {
    setAddEditObject((prevState: any) => ({
      ...prevState,
      MobileNo: SelectedMobileNumber,
    }));
  }, [SelectedMobileNumber]);

  //Dragdrop starts
  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 20,
    ObjectType: 20,
    MaxAllowedFiles: 1,
    UploadType: 1,
    FolderName: "User",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(false);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
    // SaveFiles(ChildData);
  }

  function SaveFiles() {
    // call this function for saving attachments, when you get this function responce call actuall function who save data in table.
    // let uploadFileList = UploadFileList;

    if (
      uploadFileList &&
      uploadFileList.length > 0 &&
      !uploadFileList[0].AlreadyUploaded
    ) {
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = 1;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(AppContext.FilesAPI + "api/PTAttachment/SaveFilesData", object)
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            saveScreenData(l_response); // call actuall function who save data in table
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else saveScreenData([]);
  }
  //Dragdrop ends

  function setImageData(item: any) {
    let l_PTUploadedFiles: any = [];

    if (item.PageMainImageURL !== "") {
      let obj: any = {};
      obj.Name = item.ImageURL;
      obj.FileURLDisplay = AppContext.GetFileIconToDisplay(
        item.PageMainImageURL
      );
      obj.FileURL = item.PageMainImageURL;
      obj.AlreadyUploaded = true;
      l_PTUploadedFiles.push(obj);
    }

    setDragDropFeatures((prevState: any) => ({
      ...prevState,
      ObjectID: item.PTStaticPageID,
      PTUploadedFiles: l_PTUploadedFiles,
    }));
  }

  // start add Component page code
  const [isAddNewComponent2, setIsAddNewComponent2] = useState(0);
  const [infoObj, setInfoObj] = useState<InfoObject>({
    ComponentName: "",
    TypeID: 1,
    PTHTMLTemplateID: 0,
    HTMLContents: "",
  });

  const [componentStates, setComponentStates] = useState<{
    [pageId: number]: {
      isAddNewComponent2: number;
      infoObj: InfoObject;
    };
  }>({});

  const [htmlTemplates, setHtmlTemplates] = useState<Template[]>([]);
  const [mvLocations, setMvLocations] = useState<MVLocation[]>([]);
  const [errorMessages, setErrorMessages] = useState<{ [key: number]: string }>(
    {}
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = (await loadScreenFieldsData()) as ApiResponse | undefined;

        if (res?.data) {
          setHtmlTemplates(res.data.templates || []);
          setMvLocations(res.data.locations || []);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };
    fetchData();
  }, []);

  const validateField = (id: number) => {
    let msg = "";
    if (id === 10 && !infoObj.ComponentName) msg = "Component Name is required";
    if (id === 20 && infoObj.TypeID === 2 && infoObj.PTHTMLTemplateID === 0)
      msg = "Select a Template";
    if (id === 25 && infoObj.TypeID === 3 && infoObj.PTHTMLTemplateID === 0)
      msg = "Select a User Reference";
    if (id === 30 && infoObj.TypeID !== 3 && !infoObj.HTMLContents)
      msg = "HTML content is required";

    setErrorMessages((prev) => ({ ...prev, [id]: msg }));
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setInfoObj((prev) => ({
      ...prev,
      [name]:
        name === "TypeID" || name === "PTHTMLTemplateID"
          ? Number(value)
          : value,
    }));
  };

  const handleEditorChange = (content: string) => {
    setInfoObj((prev) => ({ ...prev, HTMLContents: content }));
    validateField(30);
  };

  // const handleSave = () => {
  //   console.log("Saving component:", infoObj);
  //   alert("Component saved successfully!");
  // };

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <div className="flex-da flex-gap10">
              <div className="field-input">
                <input
                  type="text"
                  placeholder="Name"
                  value={searchObject.searchTerm}
                  onChange={(e) => {
                    setSearchObject((prevState: any) => ({
                      ...prevState,
                      searchTerm: e.target.value,
                    }));
                  }}
                  className="input-field"
                  style={{ width: "200px" }}
                />
              </div>
              <div className="field-input">
                <select
                  value={searchObject.statusFilter}
                  onChange={(e) => {
                    setSearchObject((prevState: any) => ({
                      ...prevState,
                      statusFilter: e.target.value,
                    }));
                  }}
                  className="input-field input-select"
                >
                  <option value="All">All</option>
                  <option value="Active">Active</option>
                  <option value="InActive">InActive</option>
                </select>
              </div>
              <div className="flex-daj btn-start">
                <a onClick={loadFilteredData} className="btn-primary flex-daj">
                  Apply
                </a>
              </div>
            </div>
            <span></span>
            <div className="flex-daj flex-gap10">
              <a
                className="link-btn btn-link-m"
                onClick={() => ClearAllFilters()}
              >
                Clear All Filters
              </a>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      PTStaticPageID: 0,
                      Name: "Untitled Page",
                      MetaTitle: "",
                      MetaKeywords: "",
                      MetaDescription: "",
                      ExtraTextField1: "",
                      ExtraTextField2: "",
                      PTOrderBy: thisGridListData.length + 1,
                      IsHideHeader: false,
                      IsHideFooter: false,
                      Media: [],
                    });
                    setIsAddNew(1);
                    SetSelectedMobileNumber("");
                    loadScreenFieldsData();
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() => DownloadClientsDataInExcel("tblpages", "Pages")}
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto-sm">
            <table className="reuse-table" id="tblpages">
              <thead>
                <tr>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Name
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "Name")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("Name")}
                          title={"Sort By Mover Type"}
                        >
                          <span id={"imgSort" + "Name"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Meta Title
                        <a
                          onClick={(e) => ShowColumnFilterList(e, "MetaTitle")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MetaTitle")}
                          title={"Sort By Meta Title"}
                        >
                          <span id={"imgSort" + "MetaTitle"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Meta Description
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MetaDescription")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() =>
                            LoadWithSelectedSort("MetaDescription")
                          }
                          title={"Sort By Meta Description"}
                        >
                          <span id={"imgSort" + "MetaDescription"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Meta Keywords
                        <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MetaKeywords")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MetaKeywords")}
                          title={"Sort By Meta Keywords"}
                        >
                          <span id={"imgSort" + "MetaKeywords"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>{item.Name}</td>
                          <td>{item.MetaTitle}</td>
                          <td>{item.MetaDescription}</td>
                          <td>{item.MetaKeywords}</td>
                          <td className="p-all0">
                            <select
                              className="input-field op-rad w-100 text-left"
                              value={item.Status === 1 ? "Active" : "InActive"}
                              onChange={(e) => {
                                const newValue =
                                  e.target.value === "Active" ? 1 : 0;
                                handleStatusChange(item, newValue);
                              }}
                            >
                              <option value="Active">Active</option>
                              <option value="InActive">InActive</option>
                            </select>
                          </td>

                          <td>
                            <div className="flex-daj gap-10">
                              <a
                                href={`${baseUrl}${item.PageUrl}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Preview"
                              >
                                <img
                                  src="images/eye-t.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    `${baseUrl}${item.PageUrl}`
                                  );
                                  checkValidation("copy");
                                }}
                                title="Click to copy the link"
                              >
                                <img
                                  src="images/clipboard.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Copy Link"
                                />
                              </a>
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  SetSelectedMobileNumber("");
                                  loadScreenFieldsData();
                                  setAddEditObject({
                                    PTStaticPageID: item.PTStaticPageID,
                                    Name: item.Name,
                                    MetaTitle: item.MetaTitle,
                                    MetaKeywords: item.MetaKeywords,
                                    MetaDescription: item.MetaDescription,
                                    ExtraTextField1: item.ExtraTextField1,
                                    ExtraTextField2: item.ExtraTextField2,
                                    PTOrderBy: item.PTOrderBy,
                                  });
                                  setImageData(item);
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.PTStaticPageID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Page Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Name}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                  onBlur={(e) => handleBlurSave("Name", e.target.value)}
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Meta Title:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.MetaTitle}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaTitle: e.target.value,
                    }))
                  }
                  onBlur={(e) => handleBlurSave("MetaTitle", e.target.value)}
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Meta Keywords:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.MetaKeywords}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaKeywords: e.target.value,
                    }))
                  }
                  onBlur={(e) => handleBlurSave("MetaKeywords", e.target.value)}
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Meta Description:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.MetaDescription}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      MetaDescription: e.target.value,
                    }))
                  }
                  onBlur={(e) =>
                    handleBlurSave("MetaDescription", e.target.value)
                  }
                />
              </div>

              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">
                  Page Location:
                </span>
                <select
                  className="input-field w-100"
                  value={addEditObject.ExtraTextField1}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ExtraTextField1: e.target.value,
                    }))
                  }
                  onBlur={(e) =>
                    handleBlurSave("ExtraTextField1", e.target.value)
                  }
                >
                  <option value="0">None</option>
                  <option value="1">Services</option>
                  <option value="2">Locations</option>
                  <option value="3">Sub Locations</option>
                  {/* {dropDowndata &&
                    dropDowndata.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.pid}>{item.Name}</option>
                      </React.Fragment>
                    ))} */}
                </select>
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Page Url:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.ExtraTextField2}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ExtraTextField2: e.target.value,
                    }))
                  }
                  onBlur={(e) =>
                    handleBlurSave("ExtraTextField2", e.target.value)
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Order Number:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.PTOrderBy}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PTOrderBy: e.target.value,
                    }))
                  }
                  onBlur={(e) => handleBlurSave("PTOrderBy", e.target.value)}
                />
              </div>
            </div>
            <div className="grid-d mt-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  <div className="field-input grid-d g-c-fw">
                    <DragDrop
                      ParentFeatures={dragDropFeatures}
                      DragDropCallback={handleDragDropCallback}
                      TriggerChild={triggerChild}
                    />
                  </div>
                </span>
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() =>
                    setIsAddNewComponent2(isAddNewComponent2 === 0 ? 1 : 0)
                  }
                >
                  Add Component
                </a>
              </div>
            </div>
            {/* <div className="flex-daj btn-start">
              <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(isAddNewComponent === 0 ? 1 : 0)}
                  style={{ cursor: "pointer" }}
                >
                  Add Component
                </a>
              <AddComponentSection />
              
            </div> */}

            {isAddNewComponent2 === 1 && (
              <div className="inline-block-d text-center width-100 reuse-border p-all20 mt-20">
                <div className="grid-d fr-111 gap-20">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Component Name:
                    </span>
                    <input
                      className="input-field w-100"
                      name="ComponentName"
                      placeholder="Component Name"
                      value={infoObj.ComponentName}
                      onChange={handleInputChange}
                      onBlur={() => validateField(10)}
                    />
                    {errorMessages[10] && (
                      <span className="text-danger font-11">
                        {errorMessages[10]}
                      </span>
                    )}
                  </div>

                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">Type:</span>
                    <select
                      className="input-field w-100"
                      name="TypeID"
                      value={infoObj.TypeID}
                      onChange={handleInputChange}
                    >
                      <option value={1}>HTML</option>
                      <option value={2}>Template</option>
                      <option value={3}>User Reference</option>
                    </select>
                  </div>

                  {infoObj.TypeID === 2 && (
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Template Type:
                      </span>
                      <select
                        className="input-field w-100"
                        name="PTHTMLTemplateID"
                        value={infoObj.PTHTMLTemplateID}
                        onChange={handleInputChange}
                        onBlur={() => validateField(20)}
                      >
                        <option value={0}>Select</option>
                        {Array.isArray(htmlTemplates) &&
                          htmlTemplates.map((item: any) => (
                            <option
                              key={item.PTHTMLTemplateID}
                              value={item.PTHTMLTemplateID}
                            >
                              {item.Name}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}

                  {infoObj.TypeID === 3 && (
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        User Reference Type:
                      </span>
                      <select
                        className="input-field w-100"
                        name="PTHTMLTemplateID"
                        value={infoObj.PTHTMLTemplateID}
                        onChange={handleInputChange}
                        onBlur={() => validateField(25)}
                      >
                        <option value={0}>Select</option>
                        {Array.isArray(mvLocations) &&
                          mvLocations.map((item: any) => (
                            <option
                              key={item.MVLocationsID}
                              value={item.MVLocationsID}
                            >
                              {item.Name}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>
                <div className="grid-d mt-20">
                  {infoObj.TypeID !== 3 && (
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        HTML Content:
                      </span>
                      <div className="ck-editor-container">
                        <QuillEditor
                          value={addEditObject.HTMLContents}
                          onChange={(value: string) =>
                            setAddEditObject((prev: any) => ({
                              ...prev,
                              HTMLContents: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => checkValidation()}
                    >
                      Save
                    </a>
                  </div>
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setIsAddNewComponent2(0)}
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            )}
          </>
        </div>
      )}
    </div>
  );
}

export default Pages;
